export default __webpack_public_path__ + "static/media/header-img.6b75931a.png";